// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict';

import HTTP from "./http-server";

export default {
  refreshToken: async function (jwt) {
    HTTP.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
  },
  login: async function (credentials) {
    let response = await HTTP.post('auth', credentials);
    console.log(response)
    console.log(HTTP)
    if (response.status == 200) {
      let jwt = response.data.token;
      HTTP.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
      return jwt;
    }
    return false;
  },
  logout: async function () {
    delete HTTP.defaults.headers.common['Authorization'];
    return true;
  },
  sendPasswordResetRequest: async function (email) {
    let response = await HTTP.post('password-reset-request', { email: email });
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  resetPassword: async function (id, password) {
    let response = await HTTP.post('password-reset', { id: id, password: password });
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data);
  },
  validateRequestID: async function (id) {
    let response = await HTTP.get(`password-reset/${id}/`);
    if (response.status == 200) {
      return response.data.Success;
    }
    throw new Error(response.data);
  },
  changePassword: async function (data) {
    let response = await HTTP.post("v1/changepassword", data)
    if (response.status == 200) {
      return response.data.Success;
    }
    throw new Error(response.data)
  },
}
